import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';
import OperatorCombobox from 'components/comboboxes/OperatorCombobox';
import { HubertSlider } from 'components/HubertUI/HubertSlider';
import type { TQuestionRuleCondition } from 'types/rules.types';

interface Props extends TRuleEditorCommonProps {
  condition: TQuestionRuleCondition;
  onChange: (patch: Partial<TQuestionRuleCondition>) => void;
}

const RuleConditionByRandomNumber = ({ condition, isReadOnly, onChange }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div>
      <div className="my-4 flex flex-row items-center gap-2">
        <Text className="hubert-vertical-center">{t('question.ruleConditions.operatorLabel')}</Text>
        <OperatorCombobox
          include={['LESS_THAN', 'GREATER_THAN']}
          disabled={isReadOnly}
          value={condition.operator}
          onValueChange={(value) => onChange({ operator: (value as string) || undefined })}
        />
      </div>

      <div className="my-4 flex flex-col justify-between">
        <Text className="hubert-vertical-center">{t('question.ruleConditions.valueLabel')}</Text>
        <HubertSlider
          disabled={isReadOnly}
          value={Array.isArray(condition.value) && condition.value.length ? condition.value.map(Number) : [0]}
          min={0}
          max={1}
          step={0.01}
          onValueChange={(value) => onChange({ value })}
        />
      </div>

      {condition.value !== undefined && condition.operator ? (
        <div className="hubert-vertical-center bg-primary-50 flex flex-col justify-between gap-2 rounded-md p-4">
          <Text>
            This question will <strong>only be shown</strong> if the random number is{' '}
            <strong>{condition.operator.toLowerCase().split('_').join(' ')}</strong> <strong>{condition.value}</strong>.
          </Text>
        </div>
      ) : null}
    </div>
  );
};

export default RuleConditionByRandomNumber;
